"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { motion } from "framer-motion";
import { HealerResultCard, type SearchHealerResult } from "@/features/search";
import type { AppLocale } from "@/core/i18n/config";
import { Button } from "@/shared/ui/button";
import type { Service } from "@/features/services/constants/services-data";
interface ServiceCounsellorsSectionProps {
  service: Service;
  healers: SearchHealerResult[];
  locale: AppLocale;
}
export function ServiceCounsellorsSection(t0) {
  const $ = _c(17);
  const {
    service,
    healers,
    locale
  } = t0;
  const browseHref = `/en/search?q=${encodeURIComponent(service.title)}&type=healers`;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      y: 20
    };
    t2 = {
      opacity: 1,
      y: 0
    };
    t3 = {
      once: true,
      margin: "-100px"
    };
    t4 = {
      duration: 0.7,
      ease: "easeOut"
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <motion.div initial={t1} whileInView={t2} viewport={t3} transition={t4} className="mx-auto max-w-2xl text-center"><span className="mb-3 block text-xs font-semibold tracking-[0.2em] text-primary uppercase">Meet Our Professionals</span><h2 className="font-heading text-[2.5rem] leading-[1.1] font-bold tracking-tight text-foreground sm:text-[3.2rem]">Find Someone You Feel Comfortable Talking To</h2></motion.div>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== healers || $[6] !== locale) {
    t6 = healers.length > 0 ? <div className="mt-16 grid grid-cols-1 gap-6 lg:grid-cols-3">{healers.slice(0, 3).map(healer => <HealerResultCard key={healer.id} healer={healer} locale={locale} />)}</div> : <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="mt-16 rounded-3xl border border-border bg-muted/40 p-10 text-center text-sm text-muted-foreground">New professionals for this specialty are joining regularly. Browse all verified professionals to find your match today.</motion.div>;
    $[5] = healers;
    $[6] = locale;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t10;
  let t7;
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      opacity: 0,
      y: 12
    };
    t8 = {
      opacity: 1,
      y: 0
    };
    t9 = {
      once: true
    };
    t10 = {
      duration: 0.5,
      delay: 0.15
    };
    $[8] = t10;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t10 = $[8];
    t7 = $[9];
    t8 = $[10];
    t9 = $[11];
  }
  let t11;
  if ($[12] !== browseHref) {
    t11 = <motion.div initial={t7} whileInView={t8} viewport={t9} transition={t10} className="mt-10 flex justify-center"><Button size="lg" variant="outline" render={<Link href={browseHref} />}>View All Professionals</Button></motion.div>;
    $[12] = browseHref;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11 || $[15] !== t6) {
    t12 = <section className="relative bg-background py-24 sm:py-32"><div className="mx-auto max-w-6xl px-6 sm:px-10 lg:px-12">{t5}{t6}{t11}</div></section>;
    $[14] = t11;
    $[15] = t6;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  return t12;
}